import useTranslation from '@space-lib/hooks/useTranslation'
import { useInfiniteRequest } from '@space-shell/common/hooks/useInfiniteRequest'

import type {
  ActivitieNotificationList,
  ProductNotificationList
} from '@space-shell/common/services/notificationCenter'
import {
  NotificationsEndpoints,
  NotificationsService,
  Role,
  Context
} from '@space-shell/common/services/notificationCenter'
import type { ApiError } from '@space-shell/config/request/manager/httpManager'
import type { UseInfiniteQueryResult } from '@tanstack/react-query/build/lib/types'

const PAGE_SIZE = 20

export function useNotifications(
  type: Context.ACTIVITIES
): UseInfiniteQueryResult<ActivitieNotificationList, ApiError>

export function useNotifications(
  type: Context.PRODUCTS
): UseInfiniteQueryResult<ProductNotificationList, ApiError>

export function useNotifications(context: Context) {
  const {
    i18n: { language }
  } = useTranslation()

  const role = context === Context.PRODUCTS ? Role.CONSUMER : undefined

  return useInfiniteRequest(
    [NotificationsEndpoints.notifications(), context],
    ({ pageParam }) => {
      return NotificationsService.getNotifications({
        language: language.toLocaleLowerCase(),
        context,
        nextToken: pageParam,
        size: PAGE_SIZE,
        role
      })
    },
    {
      getNextPageParam: (lastPage) => {
        return lastPage?.nextToken ?? undefined
      }
    }
  )
}
